import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getUser } from 'ServerAPI'
import { AppRoutes } from '~/AppRoutes'
import { CircularProgress } from '~/components/base/CircularProgress/CircularProgress'
import { formatBytes } from '~/Util'
import { formatUnixTime } from '~/components/admin/formatUnixTime'
import './UserView.scss'

const userDisplayEntries = [ 'userId', 'apiKey', 'secreteAPIKey', 'name', 'eMail', 'permanent', 'activeTime', 'usedBytes', 'totalBytes' ]

const hasValue = value => value !== null && value !== undefined && value !== ''

const getUsersSearchUrl = (searchBy, search) => {
  const queryParams = new URLSearchParams()
  queryParams.set('sortBy', searchBy)
  queryParams.set('search', String(search))
  return `${AppRoutes.AdminRecentUsers}?${queryParams.toString()}`
}

export const UserView = () => {
  const { id } = useParams()
  const [ user, setUser ] = useState(null)
  const [ error, setError ] = useState(null)

  useEffect(() => {
    let isMounted = true
    getUser(id)
      .then(data => {
        if (isMounted) setUser(data)
      })
      .catch(err => {
        if (isMounted) setError(err)
      })
    return () => {
      isMounted = false
    }
  }, [ id ])

  if (error) {
    return <div className="admin-panel__error">{String(error?.message || error)}</div>
  }

  if (!user) {
    return (
      <div className="admin-panel__loading">
        <CircularProgress endless percents={80} transparent />
      </div>
    )
  }

  return (
    <div className="stats">
      {userDisplayEntries.map(key => {
        const value = user[key]
        if (value === undefined) return null
        let displayValue = value
        if (key === 'usedBytes' || key === 'totalBytes') displayValue = formatBytes(value)
        if (key === 'activeTime') displayValue = formatUnixTime(value)
        const searchable = (key === 'apiKey' || key === 'secreteAPIKey') && hasValue(value)
        return (
          <div key={key} className="stats__item">
            <span className="stats__label">
              {key}
              :
            </span>
            <span className="stats__value">
              {searchable
                ? <Link className="admin-panel__link" to={getUsersSearchUrl(key, value)}>{String(displayValue)}</Link>
                : displayValue}
            </span>
          </div>
        )
      })}
      <div className="stats__item">
        <Link
          className="admin-panel__link"
          to={`${AppRoutes.AdminRecentProjects}?sortBy=userId&search=${user.userId}`}
        >
          Search projects
        </Link>
      </div>
      <div className="stats__item">
        <Link
          className="admin-panel__link"
          to={`${AppRoutes.AdminRecentMediaFiles}?sortBy=userId&search=${user.userId}`}
        >
          Search media files
        </Link>
      </div>
    </div>
  )
}
